import { Node, mergeAttributes } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import FlexColumn from "./FlexColumn.vue";

export default Node.create({
  name: "flexcolumn",

  content: "(notification* imagecaption* paragraph*)+",
  isolating: true,
  draggable: false,

  addAttributes() {
    return {
      class: "aunfcol col"
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[class*=col]"
      }
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0
    ];
  },

  addNodeView() {
    return VueNodeViewRenderer(FlexColumn);
  }
});
